import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import Form from "./Form";
import {UsePost, UsePut} from "../../hooks/http";
import {useNavigate} from "react-router-dom";
import {UseMessage} from "../../hooks/UseMessage";

const Create = () => {
    const navigate = useNavigate()
    const [errors, setErrors] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [enterprises, setEnterprises] = useState([])
    const [domains, setDomains] = useState([])


    const handleCreate = (PostData) => {
        setIsLoading(true)
        UsePost(
            '/landings/upsert/',
            {data: PostData}
        ).then((response) => {
            if(response.code >= 200 && response.code <= 299){
                navigate(`/landings/${response.id}`)
                UseMessage('success', 'Landing has been successfully created')
            }else{
                setErrors(response.errors)
            }
            setIsLoading(false)
        })
    }



    const handleDomains = async (ev) => {
        const requestDomains = await UsePut(
            "/domains/get",
            {data: {id_enterprise: ev.value}, toArray: true, propLabel: 'name'}
        )
        setDomains(requestDomains)
    }



    const GetEnterprises = async () => {
        return await UsePut(
            `/enterprises/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )
    }
 

    useEffect(() => {
        GetEnterprises().then((response) => {
            setEnterprises(response)
            setIsLoading(false)
        })
    }, [])



    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form
                                errors={errors}
                                domains={domains}
                                isReady={!isLoading}
                                onSubmit={handleCreate}
                                enterprises={enterprises}
                                onChangeEnterprise={handleDomains}
                            />
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Create